module.exports = __webpack_public_path__ + "static/media/spinner_transparent.5ae2a50d.gif";